import { hasInterviewRole } from "./interviewRoles";

export function profileNeedsDashboardTour(profile) {
    if (!profile || typeof profile !== "object") {
        return false;
    }

    const firstName = String(profile.first_name || "").trim();
    const lastName = String(profile.last_name || "").trim();
    const loginCount = Number(profile.login_count);

    return (
        firstName.length === 0 ||
        lastName.length === 0 ||
        !hasInterviewRole(profile.role) ||
        !Number.isFinite(loginCount) ||
        loginCount <= 0
    );
}
